import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import MovieCard from './MovieCard';

const ContentRow = ({ title, items = [], variant = 'poster', loading = false }) => {
  const ref = useRef(null);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.max(600, el.clientWidth * 0.8), behavior: 'smooth' });
  };

  return (
    <section className="mb-10 group/row">
      <div className="flex items-end justify-between px-10 mb-4">
        <h2 className="row-title text-xl md:text-2xl font-semibold text-white">{title}</h2>
      </div>

      <div className="relative">
        <button
          onClick={() => scrollBy(-1)}
          className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 z-30 w-10 h-16 items-center justify-center bg-black/60 hover:bg-black/85 rounded-r-xl opacity-0 group-hover/row:opacity-100 transition"
          aria-label="Scroll left"
        >
          <ChevronLeft className="text-white" />
        </button>

        <div
          ref={ref}
          className="row-scroll overflow-x-auto overflow-y-visible px-10 py-6 flex gap-4 scroll-smooth"
        >
          {loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div
                  key={i}
                  className={`flex-shrink-0 ${variant === 'backdrop' ? 'w-[340px] h-[190px]' : 'w-[200px] h-[300px]'} rounded-xl bg-white/5 animate-pulse`}
                />
              ))
            : items.map((it) => (
                <MovieCard key={`${it.media_type || 'm'}-${it.id}`} item={it} variant={variant} />
              ))}
        </div>

        <button
          onClick={() => scrollBy(1)}
          className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-30 w-10 h-16 items-center justify-center bg-black/60 hover:bg-black/85 rounded-l-xl opacity-0 group-hover/row:opacity-100 transition"
          aria-label="Scroll right"
        >
          <ChevronRight className="text-white" />
        </button>
      </div>
    </section>
  );
};

export default ContentRow;
